const getOr = require('lodash/fp/getOr');
const merge = require('lodash/fp/merge');
const base64 = require('base-64');
const parseRequestMetaData = require('../utils/parse-request-meta-data');
const config = require('../config'); const apiConfig = require('../api-config');

const headers = { Accept: 'application/json' }
const defaultOpts = { headers, method: 'POST', json: true };
const urls = {
  alternatives: `${config.baseUrl}/alternatives/${apiConfig.apiversion}/alternatives-value-movement`,
  'fx-forwards': `${config.baseUrl}/fx-forwards/${apiConfig.apiversion}/fx-forwards-value-movement`,
  cash: `${config.baseUrl}/cash/${apiConfig.apiversion}/cash-value-movement`,
  various: `${config.baseUrl}/various/${apiConfig.apiversion}/various-value-movement`,
  options: `${config.baseUrl}/options/${apiConfig.apiversion}/options-value-movement`,
  loan: `${config.baseUrl}/loan/${apiConfig.apiversion}/loan-value-movement`,
  bonds: `${config.baseUrl}/bonds/${apiConfig.apiversion}/bonds-value-movement`,
  equity:  `${config.baseUrl}/equities/${apiConfig.apiversion}/equity-value-movement`,
  mmarket: `${config.baseUrl}/money-market/${apiConfig.apiversion}/money-market-value-movement`,
}

function parseValueMovement(data) {
   if((!data) || data.length==0){
     return null;
    }
    else {
      return JSON.stringify(data);
    }
}

// params:
// pfRelId, userId, assetShortDesc, branchCode
function fetchData ({ metaData, requestBody }, requestHandler) {
  // data formation
  const meta = parseRequestMetaData(metaData);
  const parsedRequestBody = JSON.parse(base64.decode(requestBody))
  const request = {
    method: 'POST',
    url: urls[parsedRequestBody.subAssetsDesc],
    Accept: 'application/json',
    headers: merge(headers, meta.headers),
    body: {
      userId: meta.qs.userId,
      branchCode: meta.portfolio.branchCode,
      psActNmb: parsedRequestBody.psActNmb,
      psSecNmb: parsedRequestBody.psActNmb,
      psCcy: parsedRequestBody.psCcy || '',
      psRicCode: parsedRequestBody.ricCode || '',
      numberOfRows: parsedRequestBody.num_days
    },
    json: true,
  }
  // serialize
  return requestHandler(request)
    .then(parseValueMovement)
    .catch(() => null)
}

function addRoutes({ requestHandler } = {}) {
  return app => app
    .match(`[{keys:metaData}].priceHistory.getData.[{keys:requestBody}].[{keys:ran_str}]`, requests => {
      return Promise.all(requests.map(
        ({ req, res }) => fetchData(req.params, requestHandler)
        .then(response => res.value(response))
      ))
    }
      
    )
}

module.exports = addRoutes